import { useTheme } from '../../theme/ThemeContext';
function dayButtonCursor(available, isDisabled) {
  if (isDisabled && available) return 'not-allowed';
  if (available) return 'pointer';
  return 'default';
}
export const useCalendarStyles = () => {
  const theme = useTheme();
  const monthLabelStyle = {
    flex: 1,
    textAlign: 'center',
    fontWeight: theme.fontWeights.bold,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.text,
    textTransform: 'uppercase'
  };
  const dayHeaderStyle = {
    textAlign: 'center',
    fontSize: theme.fontSizes.xs,
    color: theme.colors.textDisabled,
    textTransform: 'uppercase'
  };
  const navBtnStyle = disabled => ({
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    cursor: disabled ? 'default' : 'pointer',
    color: disabled ? theme.colors.textDisabled : theme.colors.text
  });
  const dayBtnColors = (available, isSelected) => {
    if (isSelected) {
      return {
        backgroundColor: theme.colors.primary,
        color: theme.colors.background,
        border: `1px solid ${theme.colors.primary}`
      };
    }
    if (available) {
      return {
        backgroundColor: 'transparent',
        color: theme.colors.primary,
        border: 'none'
      };
    }
    return {
      backgroundColor: 'transparent',
      color: theme.colors.textDisabled,
      border: '1px solid transparent'
    };
  };
  const dayBtnStyle = (available, isSelected, isDisabled) => Object.assign({
    width: '34px',
    height: '34px',
    borderRadius: theme.radius.full,
    boxSizing: 'border-box',
    fontSize: theme.fontSizes.sm,
    fontWeight: available ? theme.fontWeights.bold : theme.fontWeights.normal,
    cursor: dayButtonCursor(available, isDisabled)
  }, dayBtnColors(available, isSelected), {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });
  const disabledContainerStyle = {
    opacity: 0.38
  };
  return {
    monthLabelStyle,
    dayHeaderStyle,
    navBtnStyle,
    dayBtnStyle,
    disabledContainerStyle
  };
};